import { CalendarNotificationUpdateLog } from '../store/schema/CalendarNotificationDiagnosticsStore';
import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'insertNotificationUpdateLogMutator',
    (notificationUpdateLog: CalendarNotificationUpdateLog) => {
        getStore().notificationUpdateLogs.push(notificationUpdateLog);
    }
);
